import { DataObject } from '@shared/models/data-object.model';
import { EntityType } from '@shared/models/entity-enum';

export const getPropertyMarketByUsage = (record: DataObject, usage: string): string =>
  record.usages.find(usageData => usageData.ref_property_usage_type_desc === usage)?.lig_geography?.market_desc ?? '';

export const getTIMMarketList = (record: DataObject): string[] =>
  record.target_geography?.lig_geography.reduce(
    (listOfMarkets, currentLoc) =>
      currentLoc.market_desc ? [...listOfMarkets, currentLoc.market_desc] : listOfMarkets,
    []
  );

export const ACTION_DEATILS_PAGE_BY_ENTITY = {
  [EntityType.Property]: 'Property Detail Page',
  [EntityType.Tim]: 'TIM Detail Page',
  [EntityType.Availability]: 'Availability Detail Page',
};
